import React from "react";
import PropTypes from "prop-types";
import SelectDropdown from "components/forms/select-dropdown";

const DATE_PRESETS = [
  { key: "last7", label: "Last 7 Days" },
  { key: "last30", label: "Last 30 Days" },
  { key: "last90", label: "Last 90 Days" },
  { key: "thisMonth", label: "This Month" },
  { key: "lastMonth", label: "Last Month" },
  { key: "ytd", label: "Year to Date" }
];

const EmailQualityFilters = ({
  filters,
  filterOptions,
  onFilterChange,
  onApply,
  onDatePreset,
  onExport,
  isFetching,
  lockCompany
}) => {
  return (
    <div className="email-quality-filters">
      <div className="date-presets">
        {DATE_PRESETS.map(preset => (
          <button
            key={preset.key}
            className="button tiny secondary preset-button"
            onClick={() => onDatePreset(preset.key)}
            disabled={isFetching}
          >
            {preset.label}
          </button>
        ))}
      </div>

      <div className="filters-row">
        {!lockCompany && (
          <div className="filter-group">
            <label>Company</label>
            <SelectDropdown
              options={[
                { value: "", text: "All Companies" },
                ...(filterOptions?.companies || [])
              ]}
              value={filters.companyGuid}
              onChange={value => onFilterChange("companyGuid", value)}
              placeHolder="All Companies"
              disabled={isFetching}
            />
          </div>
        )}

        <div className="filter-group">
          <label>Category</label>
          <SelectDropdown
            options={[
              { value: "", text: "All Categories" },
              ...(filterOptions?.categories || [])
            ]}
            value={filters.category}
            onChange={value => onFilterChange("category", value)}
            placeHolder="All Categories"
            disabled={isFetching}
          />
        </div>

        <div className="filter-group">
          <label>Team</label>
          <SelectDropdown
            options={[
              { value: "", text: "All Teams" },
              ...(filterOptions?.teams || [])
            ]}
            value={filters.teamId}
            onChange={value => onFilterChange("teamId", value)}
            placeHolder="All Teams"
            disabled={isFetching}
          />
        </div>

        <div className="filter-group">
          <label>Coach</label>
          <SelectDropdown
            options={[
              { value: "", text: "All Coaches" },
              ...(filterOptions?.coaches || [])
            ]}
            value={filters.coachId}
            onChange={value => onFilterChange("coachId", value)}
            placeHolder="All Coaches"
            disabled={isFetching}
          />
        </div>

        <div className="filter-group filter-actions">
          <button
            className="button primary"
            onClick={onApply}
            disabled={isFetching}
          >
            Apply Filters
          </button>
          <button
            className="button secondary export-button"
            onClick={onExport}
            disabled={isFetching}
          >
            Export CSV
          </button>
        </div>
      </div>
    </div>
  );
};

EmailQualityFilters.propTypes = {
  filters: PropTypes.shape({
    companyGuid: PropTypes.string,
    category: PropTypes.string,
    teamId: PropTypes.string,
    coachId: PropTypes.string
  }).isRequired,
  filterOptions: PropTypes.shape({
    companies: PropTypes.array,
    categories: PropTypes.array,
    teams: PropTypes.array,
    coaches: PropTypes.array
  }),
  onFilterChange: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  onDatePreset: PropTypes.func.isRequired,
  onExport: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  // When true, the Company dropdown is hidden (company is pinned by the parent, e.g. the per-company tab).
  lockCompany: PropTypes.bool
};

export default EmailQualityFilters;
